import { Delivery, Exercise, ExerciseCorrection, Res } from '@/types'

import base from './base'

export const exerciseApi = base.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    addExercise: builder.mutation<void, FormData>({
      query: (body) => ({
        url: 'teachers/exercises',
        method: 'POST',
        body,
      }),
      invalidatesTags: (_, error) => (!error ? ['Exercise'] : []),
    }),

    getExercises: builder.query<Exercise[], void>({
      query: () => 'teachers/exercises',
      transformResponse: (res: Res<Exercise[]>) => res.data,
      providesTags: ['Exercise'],
    }),

    getExerciseDetail: builder.query<Exercise, string>({
      query: (id) => `teachers/exercises/${id}`,
      transformResponse: (res: Res<Exercise>) => res.data,
      providesTags: (_, __, id) => [{ type: 'Exercise', id }],
    }),

    editExercise: builder.mutation<void, { id: string; body: FormData }>({
      query: ({ id, body }) => ({
        url: `teachers/exercises/${id}/?_method=PUT`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_, __, { id }) => [{ type: 'Exercise', id }],
    }),

    deleteExercise: builder.mutation<void, string>({
      query: (id) => ({
        url: `teachers/exercises/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, error) => (!error ? ['Exercise'] : []),
    }),

    getDeliveries: builder.query<Delivery[], string>({
      query: (id: string) => `teachers/exercises/${id}/deliveries`,
      transformResponse: (res: Res<Delivery[]>) => res.data,
      providesTags: ['Delivery'],
    }),

    addCorrection: builder.mutation<void, ExerciseCorrection>({
      query: ({ exercise_delivery_id, ...body }) => ({
        url: `teachers/deliveries/${exercise_delivery_id}/corrections`,
        method: 'POST',
        body,
      }),
      invalidatesTags: (_, error) => (!error ? ['Delivery'] : []),
    }),

    editCorrection: builder.mutation<void, ExerciseCorrection>({
      query: ({ id, ...body }) => ({
        url: `teachers/corrections/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_, error) => (!error ? ['Delivery'] : []),
    }),
  }),
})

export const {
  useAddExerciseMutation,
  useGetExercisesQuery,
  useGetDeliveriesQuery,
  useEditExerciseMutation,
  useDeleteExerciseMutation,
  useAddCorrectionMutation,
  useEditCorrectionMutation,
  useGetExerciseDetailQuery,
} = exerciseApi
